import { useState, useEffect } from 'react';

// Возвращает true на узких экранах (телефон). Используется для адаптивного
// поведения: сайдбар → выезжающая панель, поля/таблицы под мобилку.
// Десктоп (≥768px) ведёт себя как раньше.
export function useIsMobile(maxWidth = 767): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return isMobile;
}
